import TemplateView from '../../../../TemplateView'

class BaseScopeCellContent extends TemplateView {
    constructor($el, {
        className,
    }) {
        super($el)

        this.params = {
            className,
        }

        this.state = {
            allScope: false,
            disabled: false,
            notAvailable: false,
            noAccess: false,
        }

        this.onStateChanged(() => {
            this._updateLabel()
            this._updateContainerClass()
        })
    }

    _isScopeEmpty() {
        return false
    }

    _getAllScopeMessage() {
        return ''
    }

    _getSelectedScopeMessage() {
        return ''
    }

    _getEmptyScopeMessage() {
        return ''
    }

    _getNoAccessScopeMessage() {
        return ''
    }

    _getEmptyNotAvailableScopeMessage() {
        return ''
    }

    templateHtml() {
        return '<div class="manageScopeCellContent <%=className%>">' +
               '    <span class="label"></span>' +
               '</div>'
    }

    templateModel() {
        return {
            className: this.params.className
        }
    }

    _updateLabel() {
        this.find('.label').text(this._getLabelText())
    }

    _updateContainerClass() {
        this.$el
            .toggleClass('all', this.state.allScope)
            .toggleClass('disabled', this.state.disabled)
            .toggleClass('noAccess', this._hasNoAccess())
            .toggleClass('empty', this._isScopeEmpty())
    }

    _hasNoAccess() {
        return !this.state.allScope && this.state.noAccess
    }

    _getLabelText() {
        if (this.state.disabled) {
            return '–'
        }

        if (this.state.allScope) {
            return this._getAllScopeMessage()
        }

        if (this._hasNoAccess()) {
            return this._getNoAccessScopeMessage()
        }

        if (this._isScopeEmpty()) {
            if (this.state.notAvailable) {
                return this._getEmptyNotAvailableScopeMessage()
            } else {
                return this._getEmptyScopeMessage()
            }
        }

        return this._getSelectedScopeMessage()
    }
}

export default BaseScopeCellContent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/BaseScopeCellContent.js